import { render, staticRenderFns } from "./diceSideValueSelect.vue?vue&type=template&id=7d068b7e&scoped=true&"
import script from "./diceSideValueSelect.vue?vue&type=script&lang=js&"
export * from "./diceSideValueSelect.vue?vue&type=script&lang=js&"
import style0 from "./diceSideValueSelect.vue?vue&type=style&index=0&id=7d068b7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d068b7e",
  null
  
)

export default component.exports